import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { INotification } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";
import CreateButton from "../../components/common/CreateButton";
import {Button} from "@mantine/core";
import axios from "axios";
import type { IResponse } from "../../types/api";
import { openConfirmModal } from "@mantine/modals";

interface ICategoryRecord extends Pick<INotification, '_id' | 'apiClient' | 'body' | 'createdAt' | 'createdUserName' | 'title' | 'topic'>{
    actions: unknown;
}

const CategoryList = () => {

    const { paginationState, records, handleInteraction, deleteRecord, fetchData } = useListPage({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })
    const [ selectedRows, setSelectedRows ] = React.useState<string[]>([]);

    const columns: Column<ICategoryRecord>[] =  [
        {
            Header: 'Апп',
            accessor: 'apiClient',
        },
        {
            Header: 'Контент',
            accessor: 'body'
        },
        {
            Header: 'Гарчиг',
            accessor: 'title'
        },
        {
            Header: 'Илгээсэн огноо',
            accessor: 'createdAt',
            Cell: ({ value }) => {
                return (
                    <div>
                        {dayjs(value).format('YYYY/MM/DD HH:mm:ss')}
                    </div>
                );
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} deleteRecord={deleteRecord} />
                )
            }
        },
    ];

    const confirmDelete = () => {
        openConfirmModal({
            title: 'Баталгаажуулалт',
            children: 'Сонордуулга устгах уу?',
            onConfirm() {
                void bulkDelete();
            },
            labels: {
                confirm: 'Устгах',
                cancel: 'Цуцлах'
            },
            confirmProps: {
                color: 'red'
            }
        })
    }

    const bulkDelete = async () => {
        const params = {
            ids: selectedRows
        }
        const { data } = await axios.delete<IResponse<any>>('/api/notification/by-ids', {
            data: params
        });
        if (data.statusCode === 200) {
            void fetchData();
        }
    }

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                {
                    selectedRows.length > 0 && (
                        <Button mr='xs' color='red' onClick={confirmDelete}>
                            Устгах
                        </Button>
                    )
                }
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                    onRowSelect={setSelectedRows}
                />
            </Page.Body>
        </Page>
    )
};

export default CategoryList;